// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"47":"04c83b5d","369":"2d3d54e3","398":"43453c0d","541":"58deec56","672":"d09e8c99","732":"8b803ddb","740":"d32d7b9f","756":"0b08a4db","840":"84295338","853":"51304047","886":"7a7c686b","931":"be4fc627","932":"e4c55aa5"}[chunkId] + ".js";
};